import env from '@beam-australia/react-env';

export const ENVIRONMENT = {
  LOCAL: 'local',
  DEV: 'dev',
  UAT: 'uat',
  SIT: 'sit',
  PRE: 'pre',
  PRD: 'prd',
}

export const isNotTestEnv = () => {
  switch (env('ENV')) {
    case ENVIRONMENT.PRE:
    case ENVIRONMENT.PRD:
      return true
    default:
      return false
  }
};

export const isLocalEnv = () => env('ENV') === ENVIRONMENT.LOCAL;

const reactAppEnv = () => env('ENV');

export default reactAppEnv;
